import TextField from '@mui/material/TextField';
import { ChangeEvent, useState, useEffect } from 'react';
import { useContact } from '../modules/ContactContext';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [inputName, setInputName] = useState('');
  const [inputEmail, setInputEmail] = useState('');
  const [inputMessage, setInputMessage] = useState('');
  
  const { isContactOpen, initialMessage, closeContact } = useContact();

  useEffect(() => {
    if (initialMessage) {
      setInputMessage(initialMessage + 'のお問い合わせ');
    } else {
      setInputMessage('');
    }
  }, [initialMessage, isContactOpen]);

  const handleName = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputName(e.target.value);
  };

  const handleEmail = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputEmail(e.target.value);
  };

  const handleMessage = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputMessage(e.target.value);
  };

  const submit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      alert('システムエラー: メール送信の設定が完了していません。管理者にお問い合わせください。');
      return;
    }

    const templateParams = {
      user_name: inputName,
      user_email: inputEmail,
      message: inputMessage,
    };

    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then(() => {
        alert(
          '送信が完了しました。\n入力いただいたEメールアドレスに控えのメールをお送りしましたので、ご確認ください。'
        );
        setInputName('');
        setInputEmail('');
        setInputMessage('');
        closeContact();
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        alert('送信に失敗しました。時間をおいて再度お試しください。');
      });
  };

  if (!isContactOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-60 z-[9999] flex items-center justify-center p-4 transition-opacity duration-300"
      onClick={closeContact}
    >
      <div 
        className="bg-white rounded-3xl p-8 md:p-12 w-full max-w-xl relative shadow-2xl animate-slide-up-fade"
        style={{ maxHeight: '90vh', overflowY: 'auto' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          onClick={closeContact}
          className="absolute top-4 right-6 text-4xl text-gray-400 hover:text-[#6e1e50] transition-colors"
        >
          &times;
        </button>
        <form onSubmit={submit} className="flex flex-col gap-6">
          <div className="text-center mb-4">
            <p className="text-[#6e1e50] font-bold tracking-widest text-sm mb-2">CONTACT</p>
            <h2 className="text-3xl font-bold text-[#333]">お問い合わせ</h2>
          </div>
          
          <div>
            <TextField
              label="お名前"
              required
              variant="outlined"
              value={inputName}
              onChange={handleName}
              fullWidth
            />
          </div>
          <div>
            <TextField
              label="Eメール"
              required
              variant="outlined"
              value={inputEmail}
              type="email"
              onChange={handleEmail}
              fullWidth
            />
          </div>
          <div>
            <TextField
              label="お問合せ内容"
              value={inputMessage}
              multiline
              minRows={4}
              onChange={handleMessage}
              fullWidth
              variant="outlined"
            />
          </div>
          <button 
            type="submit" 
            className="w-full py-4 mt-4 bg-[#6e1e50] text-white font-bold rounded-full text-lg shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
          >
            送 信
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
